export enum MarketPlacesEnum {
  wildberries = "wildberries",
  ozon = "ozon",
  yandexMarket = "yandexMarket",
  chestniyZnak = "chestniyZnak",
  redistribution = "redistribution",
}

export interface IError {
  errors: Record<string, string[]>;
  status: number;
  title: string;
  traceId: string;
  type: string;
}

export interface SelectOption<T = any> {
  value: T;
  label: string;
  disabled?: boolean;
  key?: any;
  title?: string;
}
